export default __webpack_public_path__ + "static/media/Beard_10_C5.8cc95b92.svg";